import React, { useCallback, type FC } from 'react';
import { useCurrentConversationId } from './hooks/useCurrentConversation';
import { ConversationView } from './ConversationView';
import { EnsureConversationHOC } from './EnsureConversation';

export const ConversationPanel: FC = () => {
    const currentConversationId = useCurrentConversationId();

    const renderer = useCallback((conversation) => <ConversationView conversation={conversation} />, []);

    return (
        <EnsureConversationHOC
            conversationId={currentConversationId}
            render={renderer}
        />
    );
};
